package org.maplibre.compose.benchmark

fun printBenchmarkBuildInfo() {
  println("MAP_BENCHMARK BUILD $BenchmarkBuildInfo")
}
